import { PROFILE_ROUTES, ROUTES } from 'configs';
import { EDIT_PROFILE } from 'constants/sidebars';
import React, { FC } from 'react';
import Linkify from 'react-linkify';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { openModal } from 'store/actionCreators/modal';
import { getAuthUser } from 'store/selectors/auth';

import { Container, FieldEditIcon, Label, StyledText, Text } from './styled';

interface ColumnInfoBlockProps {
  label: string | JSX.Element;
  text?: string;
  preventEdit?: boolean;
  addMaxWidth?: boolean;
  name?: string;
  style?: { [key: string]: string | number };
  isDescription?: boolean;
  linkifyStyle?: { [key: string]: string | number };
}

const ColumnInfoBlock: FC<ColumnInfoBlockProps> = ({
  label,
  text,
  preventEdit,
  name,
  addMaxWidth,
  style,
  isDescription,
  linkifyStyle,
}) => {
  const dispatch = useDispatch();
  const profile = useSelector(getAuthUser);
  const navigate = useNavigate();
  const openEditSidebar = (data: string) => {
    if (!data) {
      navigate(`${ROUTES.PROFILE}/${PROFILE_ROUTES.SETTINGS}#update-email`);
      return;
    }
    dispatch(
      openModal({
        data: data && {
          user: { profile: { ...profile, selectedFiled: data } },
        },
        type: EDIT_PROFILE,
        placement: 'right',
      }),
    );
  };

  return (
    <Container addMaxWidth={addMaxWidth}>
      <Label>{label}</Label>
      {text ? (
        isDescription ? (
          <Linkify
            componentDecorator={(decoratedHref, decoratedText, key) => (
              <a target="blank" href={decoratedHref} key={key}>
                {decoratedText}
              </a>
            )}
          >
            <StyledText style={linkifyStyle}>{text}</StyledText>
          </Linkify>
        ) : (
          <Text style={style}>{text}</Text>
        )
      ) : (
        <Text> - </Text>
      )}
      {!preventEdit ? (
        <FieldEditIcon title="Edit" onClick={() => openEditSidebar(name)} />
      ) : null}
    </Container>
  );
};

export default ColumnInfoBlock;
